import React from "react";
import { FormattedLog, Bullet, Highlight, Text } from "../../index.styles";

export default props => (
  <FormattedLog>
    <Bullet>&bull;</Bullet>
    <Text>changed</Text>
    <Highlight>{props.label}</Highlight>
    <Text>from</Text>
    <Highlight>{props.oldValue}</Highlight>
    <Text>to</Text>
    <Highlight>{props.newValue}</Highlight>
  </FormattedLog>
);
